const createPipeline = (pipelineArray) =>
    (subjectArray) => applyPipeline(subjectArray, pipelineArray)

function applyPipeline (values = [], pipeline = [], i = 0) {
    if (i === pipeline.length) return values
    const action = pipeline[i]
    const nextValues = values.map(action)
    return applyPipeline(nextValues, pipeline, i + 1)
}

export default createPipeline